import React from 'react'
import { Icon } from './Logo.elements'

type Props = {
  className?: string
}

export const LogoIcon = ({ className }: Props) => (
  <Icon
    aria-hidden
    className={className}
    fill="none"
    focusable={false}
    role="img"
    viewBox="0 0 135 204"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M107.892 145.899h-41.62c6.404 14.563 9.962 30.663 9.962 47.595 0 3.156-.127 6.283-.369 9.378h22.433a120.272 120.272 0 01-.369-9.378c0-16.932 3.558-33.032 9.963-47.595zM59.856 133.405h54.451a118.842 118.842 0 0120.479-25.728v-.216H39.377v.216a118.842 118.842 0 0120.479 25.728z" fill="#B1B7BA"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M134.768 95.031s2.31-37.598-36.529-37.598c-17.298 0-28.603 8.363-49.822 8.363-19.315 0-38.765-15.817-36.34-41.726 0 0-12.078 11.611-12.078 28.957 0 22.84 18.498 41.886 41.563 41.963 49.194.163 93.206.041 93.206.041z" fill="#5ECD82"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M134.768 95.031s2.895-31.194-29.335-37.373c-18.097-3.469-37.199-2.829-49.677-18.86C44.254 24.021 48.284 7.594 51.418 1c-8.077 3.712-23.664 16.147-23.664 37.424 0 32.621 32.86 44.628 43.817 48.225 27.905 9.16 63.197 8.383 63.197 8.383z" fill="#4CA9ED"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M134.768 95.023c.012-.123 1.005-11.38-5.184-21.68a.008.008 0 01-.002-.004.03.03 0 00-.004-.008.022.022 0 01-.003-.005c-3.472-6.045-9.243-11.67-18.785-14.31-.119-.037-.228-.082-.348-.12-.011-.002-.007.014-.015.014a40.215 40.215 0 00-2.724-.622l-.035-.007a44.815 44.815 0 00-2.889-.456l-.098-.01a48.966 48.966 0 00-3.048-.28l-.119-.005a56.793 56.793 0 00-3.275-.096c-17.298 0-28.603 8.362-49.822 8.362-4.252 0-8.51-.768-12.54-2.24 10.463 14.233 28.2 20.632 35.694 23.092 22.481 7.38 49.743 8.31 59.497 8.393l3.699-.01h.001v-.008z" fill="#12705C"/>
  </Icon>
)
